import { SF } from '@/storefront';
import {FontService} from "@/customizer/font-service";
import {IEditorTextElement, IEditorElement, IEditorPage} from "@/editor/base/editor.interfaces";


function preloader(pages: IEditorPage[], fontService: FontService): void {
    const fonts: { [key: string]: string[] } = {};

    pages.forEach(function (page: IEditorPage): void {
        page.elements
            .filter(function (element: IEditorElement): boolean {
                return element instanceof SF.Model.TextElement;
            })
            .forEach( (element: IEditorElement): void => {
                // find font used in rootStyle
                const textElement:IEditorTextElement = element as IEditorTextElement;
                void checkAndAdd(textElement.rootStyle, fonts);

                // find all fonts used in styles
                if (textElement.styles) {
                    Object.keys(textElement.styles).map(function (style: string): void {
                        if (textElement.styles[style]) {
                            Object.keys(textElement.styles[style]).forEach(function (char: any): void {
                                void checkAndAdd(char, fonts);
                            });
                        }
                    });
                }
            });
    });

    fontService.preLoad(fonts);

    async function checkAndAdd(stylesObject: any, fontFamilyDescriptions: { [key: string]: string[] }): Promise<void> {
        fontFamilyDescriptions = fontFamilyDescriptions || {};
        let fontFamily = stylesObject.fontFamily;

        // if a font family declaration exists
        if (fontFamily) {
            // ensure the font with the style exists
            let style = SF.Util.Fonts.getStyleFromStylesObject(stylesObject);
            await fontService.fontsMapLoaded();
            const font = fontService.get(fontFamily);

            // ensure that font, and the style exists, otherwise, we will map it
            if (!font || font.styles.indexOf(style) === -1) {
                if (fontFamily === 'Impact') {
                    fontFamily = 'Roboto';
                    style = 'r';
                } else {
                    fontFamily = 'Lato';
                }

                stylesObject.fontFamily = fontFamily;
                stylesObject.fontWeight = style === 'b' || style == 'bi' ? 'bold' : 'normal';
                stylesObject.fontStyle = style === 'i' || style == 'bi' ? 'italic' : 'normal';
            }

            // add it to list if it doesn't exist
            if (!fontFamilyDescriptions.hasOwnProperty(fontFamily)) {
                fontFamilyDescriptions[fontFamily] = [];
            }

            // add it as one of the styles if it doesn't already exist
            if (fontFamilyDescriptions[fontFamily].indexOf(style) === -1) {
                fontFamilyDescriptions[fontFamily].push(style);
            }
        }
    }
}

SF.Util.FontPreLoader = preloader;